import { useFormik } from "formik";
import toast from "react-hot-toast";
import * as Yup from "yup";
import axiosClient from "../../../../../setup/axios/axiosClient";
import store from "../../../../../setup/redux/Store";

const resetPasswordSchema = Yup.object().shape({
    currentPassword: Yup.string()
        .required("Current password is required"),
    password: Yup.string()
        .min(8, "Minimum 8 symbols")
        .required("New password is required"),
    confirmPassword: Yup.string()
        .required("Password confirmation is required")
        .oneOf([Yup.ref("password")], "Passwords must match"),
});
const useResetPasswordForm = () => {
    const {
        auth: { accessToken },
    } = store.getState()

    const formik = useFormik({
        initialValues: {
            currentPassword: "",
            password: "",
            confirmPassword: "",
        },
        validationSchema: resetPasswordSchema,
        onSubmit: async (values, { setSubmitting, resetForm, setStatus }) => {
            try {
                console.log("values", values)
                setSubmitting(true);
                const { currentPassword, password } = values

                const response = await axiosClient.post(
                    `/users/update-password?token=${accessToken}`,
                    { newPassword: password, oldPassword: currentPassword }
                )
                if (response.data.message) toast.success(response.data.message)

                resetForm();
            } catch (error: any) {
                console.log(error);
                toast.error(error.message)

                setStatus("The password reset failed. Please try again.");
            } finally {
                setSubmitting(false);
            }
        },
    });

    return {
        formData: formik.values,
        handleChange: formik.handleChange,
        handleBlur: formik.handleBlur,
        handleSubmit: formik.handleSubmit,
        isSubmitting: formik.isSubmitting,
        touched: formik.touched,
        errors: formik.errors,
        isValid: formik.isValid,
        dirty: formik.dirty,
        resetForm: formik.resetForm,
    };
};

export default useResetPasswordForm;